export interface IFinSobItem {
  value?: string | number | null
  sob?: string | number | null
}

/**
 * Algorithm to calculate Actuals and Targets FY SoB by quarters SoB and Values:
 *
 * Algorithm 1:
 * 2024: SOBFY = ((ValueQ1*SOBQ1) + (ValueQ2*SOBQ2) + (ValueQ3*SOBQ3) + (ValueQ4*SOBQ4)) / ValueFY
 * 2024: SOBFY = ((ValueQ1*SOBQ1) + (ValueQ2*SOBQ2) + (ValueQ3*SOBQ3) + (ValueQ4*SOBQ4)) / Sum(ValueQx) - used previously
 * 2025: (TES - Total Estimated Sales)
 * SOBFY = Sum(ValueQx) / ((ValueQ1/SOBQ1) + (ValueQ2/SOBQ2) + (ValueQ3/SOBQ3) + (ValueQ4/SOBQ4))
 *
 * Algorithm 2: (only for Actuals if any ValueQx === 0)
 * SOBFY = (SOBQ1 + SOBQ2 + SOBQ3 + SOBQ4) / Count(SOBQx)
 */
export const calcSobFyByQuarters = (items: IFinSobItem[], isActuals: boolean): number => {
  let newFYSob = 0

  if (items?.length > 0) {
    // For Algorithm 1
    // TES - Total Estimated Sales
    let estimatedSum = 0 // divisor
    let valSum = 0 // dividend
    let valCount = 0

    // For Algorithm 2
    let isAnyValueMissing = false
    let sobSum = 0 // dividend
    let sobCount = 0 // divisor

    items.forEach((item) => {
      const val = Number(item.value || 0)
      const sob = Number(item.sob || 0)

      // Common: use only FQ with SOB > 0
      if (sob > 0) {
        // For Algorithm 1
        if (val > 0) {
          valSum += val
          estimatedSum += val / sob
          valCount++
        }

        // For Algorithm 2
        if (!val) {
          isAnyValueMissing = true
        }
        sobSum += sob
        sobCount++
      }
    })

    const isUseAlgorithm2 = isActuals && isAnyValueMissing && sobCount > 0

    if (isUseAlgorithm2) {
      newFYSob = sobSum / sobCount
    } else {
      // Set Actuals FY SoB for all not empty Actuals
      // Set Targets FY SoB if all quarters not empty
      // Variant 1: calc for only full planned (target) data
      //if (totalCount !== 0 && curTotal !== 0 && (isActuals || valQCount === 4)) {
      // Variant 2: calc in any case
      if (valCount !== 0 && estimatedSum !== 0) {
        newFYSob = valSum / estimatedSum
      }
    }
  }

  return newFYSob
}
